import React, { useState, useContext, useEffect } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import {
    Card,
    Link,
    Container,
    Typography,
    TextField,
    Button,
    Grid,
} from '@mui/material';
import { Stack } from '../components/stack';
import { useFirebase } from '../hooks';
import { AuthContext } from '../provider/user-provider';

export const LogInScreen = () => {
    const { user } = useContext(AuthContext);
    const { auth, firebase } = useFirebase();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const history = useHistory();

    const handleChangeEmail = (e) => setEmail(e.target.value);
    const handleChangePass = (e) => setPassword(e.target.value);

    const signIn = async () => {
        console.log(email + ' ' + password);
        try {
            await auth.signInWithEmailAndPassword(email, password);

            history.push('/home');
        } catch (err) {
            alert(err.code.split('/')[1]);
        }
    };

    useEffect(() => {
        if (user)
            history.push('/home');
    }, [user]);

    return (
        <Container>
            <Grid
                display="flex"
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Stack
                    display="flex"
                    justifyConten="center"
                    alignItems="center"
                    size={20}
                >
                    <Typography
                        style={{ fontWeight: 'bold' }}
                        variant="h5"
                        gutterBottom
                    >
                        Welcome Zaalday admin web
                    </Typography>
                    <TextField
                        id="outlined-basic"
                        label="Email"
                        variant="outlined"
                        type="email"
                        fullWidth
                        onChange={handleChangeEmail}
                    />
                    <TextField
                        id="outlined-basic"
                        label="Password"
                        variant="outlined"
                        type="email"
                        fullWidth
                        onChange={handleChangePass}
                    />
                    <Button
                        onClick={signIn}
                        variant="contained"
                        color="primary"
                    >
                        Login
                    </Button>
                </Stack>
            </Grid>
        </Container>
    );
};
